/**
 * @generated SignedSource<<8420a50de5400ccf00c6cd59b00c0f6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebar_viewer$data = {
  readonly referFriendLink: boolean | null;
  readonly sidemarkTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBuyerChargeCurrency_viewer" | "CheckoutSidebarProjectPane_viewer" | "CheckoutSidebarPromotion_viewer" | "CheckoutSidebarSidemarkPane_viewer" | "CheckoutTaxExemptionCheckbox_viewer" | "CheckoutTaxExemption_viewer" | "CheckoutTotals_viewer" | "CheckoutVatReverseCharge_viewer">;
  readonly " $fragmentType": "CheckoutSidebar_viewer";
};
export type CheckoutSidebar_viewer$key = {
  readonly " $data"?: CheckoutSidebar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebar_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebar_viewer",
  "selections": [
    {
      "alias": "referFriendLink",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "REFER_FRIEND"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"REFER_FRIEND\")"
    },
    {
      "alias": "sidemarkTrade",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "checkoutSidemarkTrade"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"checkoutSidemarkTrade\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBuyerChargeCurrency_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarPromotion_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTaxExemption_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTaxExemptionCheckbox_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarProjectPane_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarSidemarkPane_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTotals_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutVatReverseCharge_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "50dfe238cbc5e6adf07fd770e665625c";

export default node;
